import React from 'react';

const ServiceSuggestion: React.FC = () => {
  return (
    <section id="service-suggestion" className="text-white relative">
      <div className="container my-36 flex justify-center">
        <img className="w-[50%]" src="/images/countfit-x-partners.jpg" alt="Countfit x Partners" />
      </div>
      <div className="relative">
        <img src="/images/meeting.jpg" alt="meeting" className="w-full object-cover" />
        <div className="container lg:px-16 lg:py-20 px-10 py-10 w-full h-full flex flex-col justify-end absolute bottom-0 left-1/2 transform -translate-x-1/2 w-full">
          <h4 className="lg:text-[2.25rem] text-[1.5rem] leading-[1.2] font-bold">
            카운트핏 서비스를 센터에 도입해보세요!
          </h4>
          <p className="lg:mt-10 mt-4 lg:text-[1.2rem] text-[0.8rem]">
            회원들에게 한차원 높은 PT 프로그램과 운동 관리 서비스를 제공하고 싶은 헬스장 사장님!
            <br className="md:block hidden" />
            이제 카운트핏 파트너스가 되어 원격피티 서비스를 PT 영업 및 재등록의 주요전략으로 활용해 보세요.
            <br className="md:block hidden" />
            PT수업 이후에도 앱을 통해 계속되는 운동 관리, 그리고 최신 디지털 기술이 적용된 운동인식밴드로 운동 미션 수행 확인까지,
            <br className="md:block hidden" />
            다른 센터에는 없는 새로운 경쟁력으로 신규 워크인 매출은 물론 기존 회원의 재등록률도 함께 높여보세요.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ServiceSuggestion;
